module.exports = __webpack_public_path__ + "static/media/tables.3da7c187.svg";